<template>
  <div
    class="searchable-input ant-select"
    :class="
      showDropdown && 'ant-select-open ant-select-focused ant-select-enabled'
    "
    style="position: relative; width: 100%"
  >
    <a-input
      :value="value"
      :placeholder="placeholder"
      size="large"
      class="ant-select-selection"
      aria-haspopup="true"
      :aria-expanded="showDropdown && true"
      @focus="showDropdown = true"
      @input="onInput"
      @blur="handleBlur"
    >
      <template #prefix>
        <slot name="prefix" />
      </template>
    </a-input>

    <span
      class="ant-select-arrow"
      @click="toggleDropdown"
      style="cursor: pointer"
    >
      <a-icon
        type="down"
        class="ant-select-arrow-icon"
        style="user-select: none"
        unselectable="on"
      />
    </span>

    <div
      v-show="showDropdown"
      class="ant-select-dropdown"
      :class="[
        'dropdown',
        listStyle === 'grid' && 'dropdown--grid',
        items.length === 0 && 'dropdown--empty',
      ]"
    >
      <div class="items" v-if="items.length > 0">
        <div
          v-for="item in items"
          :key="getItemKey(item)"
          @mousedown.prevent="selectItem(item)"
          class="dropdown__item"
        >
          <slot name="item" :item="item">
            {{ item }}
          </slot>
        </div>
      </div>

      <div v-else style="padding: 8px; color: #aaa">No results found</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: '',
    },
    items: {
      type: Array,
      required: true,
    },
    placeholder: {
      type: String,
      default: 'Search...',
    },
    itemKey: {
      type: String,
      default: null,
    },
    labelKey: {
      type: String,
      default: null,
    },
    listStyle: {
      type: String,
      default: 'list',
    },
  },
  data() {
    return {
      showDropdown: false,
      searchText: this.value,
    }
  },
  watch: {
    value(val) {
      this.searchText = val
    },
  },
  methods: {
    toggleDropdown() {
      this.showDropdown = !this.showDropdown
    },
    onInput(e) {
      const val = e.target.value
      this.$emit('input', val)
      this.$emit('search', val)
      this.showDropdown = true
    },
    selectItem(item) {
      const label = this.labelKey ? item[this.labelKey] : item
      this.$emit('input', label)
      this.$emit('select', item)
      this.showDropdown = false
    },
    handleBlur() {
      this.validateInputValue()
      this.$emit('blur')
    },
    handleClickOutside(event) {
      if (!this.$el.contains(event.target)) {
        this.showDropdown = false
      }
    },
    getItemKey(item) {
      return this.itemKey ? item[this.itemKey] : item
    },
    validateInputValue() {
      const match = this.items.find(i => i[this.labelKey] === this.value)

      if (!match) {
        this.$emit('input', '')
        this.$emit('select', null)
      }
    },
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside)
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside)
  },
}
</script>
<style lang="scss" scoped>
.dropdown {
  display: flex;
  flex-direction: column;
  gap: 12px;
  position: absolute;
  top: 50px;
  left: 0;
  right: 0;
  background: #fff;
  z-index: 1000;
  max-height: 200px;
  overflow-y: auto;
  padding: 16px 24px;

  &--grid {
    padding: 8px;
    gap: 12px;

    .items {
      display: grid;
      grid-template-columns: repeat(4, 1fr);

    }
  }

  &--empty {
    display: flex;
  }
}

.ant-select-open .ant-select-selection {
  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2) !important;
}
</style>
